export default class classVeryImg {
  static getPropsTemplate = () => ({
    CSS: [""],
    src: "",
    defaultComponent: <></>,
  });
}
